import React from 'react';
import { Card, CardContent, Box, Typography, IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import AddressDisplay from './AddressDisplay';

/**
 * AddressCard - Address displayed in a card format (for settings pages, lists, etc.)
 * 
 * @param {object} address - Address object to display
 * @param {string} title - Optional custom title (defaults to address.location_name)
 * @param {function} onEdit - Callback when edit button is clicked
 * @param {boolean} showDefaultRadius - Whether to show the default radius field
 * @param {number} elevation - Card elevation (default: 1)
 * @param {object} sx - Additional styles
 */
const AddressCard = ({
  address,
  title,
  onEdit,
  showDefaultRadius = true,
  elevation = 1,
  sx = {},
}) => {
  if (!address) {
    return null;
  }

  return (
    <Card
      elevation={elevation}
      sx={{
        height: '100%',
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        ...sx,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Header with title and edit button */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {title || address.location_name}
          </Typography>
          {onEdit && (
            <IconButton
              size="small"
              onClick={() => onEdit(address)}
              sx={{ color: '#666666', ml: 1 }}
              title="Edit Address"
            >
              <Edit fontSize="small" />
            </IconButton>
          )}
        </Box>

        {/* Address display with location icon */}
        <AddressDisplay
          address={address}
          variant="compact"
          showIcon={true}
          showDefaultRadius={showDefaultRadius}
        />
      </CardContent>
    </Card>
  );
};

export default AddressCard;
